export const locale = {
    lang: 'en',
    data: {
      'RESULTADOS': {
        'TITULO': 'REPORTING',
        'DESCRIP': 'Select an option',
        'CARGANDO': 'Loading company survey results',
        'COMINGSOON': 'COVID Survey results coming soon...',
        'VALIDANDO': {
          'BOTON': 'On validation process',
          'MENSAJE': 'The results of this product are in validation process, soon they will be made available to you',
        },
        'TABLAPRODUCTOS':{
          'COL1':'Year',
          'COL2':'Access',
          'BOT':'Access',
        },

        'SECCIONES': {
          'NOSECCIONES': 'There are not sections available',

          'CERTIFICAR': {
            'TITULO': 'Izzi',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'MEDIR': {
            'TITULO': 'MEASUREMENT',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          },
          'PULSE': {
            'TITULO': 'PULSE CHECK',
            'INFO': 'Select the year you want to consult',
            'BOTON': 'Enter'
          }
        },

        'TABPRIN':{
          'TABPRO':'Izzi processes',
          'TAB4ALL': 'FORALL results',
          'TAB4ALL2': 'Processe results',
          'TITURES': 'FORALL Results',
          'TABCER':'Measurer processes',
          'TABPULSE':'Pulse check processes',

        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL inherited results',
         'BOTON': 'Start',
         'SIN_4ALL_HEREDADAS':"You don't count on inherited FORALL results",
         'TITULOCERTIFICAR':'Certify',
         'APLICACIONANIO':'Year of application: 2019',
        },
        '4ALL':{
            'CARGANDO':'Loading FORALL results',
             'TITULO4ALL': 'PRACTICE RESULTS',
             'TABPRACTICAS':{
              'TITULOTAB': 'Practices 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC': 'Global result of FORALL practices',
              'TEXTO1':'Percentage of ',
              'TEXTO2': 'knowledge of FORALL practices',
              'TEXTO3': 'in your organization',
              'TEXTO4': 'Level of',
              'TEXTO5': 'satisfaction of the collaborators they know',
              'TEXTO6': 'FORALL practices',
            },
            'TITULOPRAC4All':{
              'TITULOTAB': 'Demographics',
              'SUBTITULO4ALL': 'Results by FORALL practices',
              'TITULOCONO': 'KNOWLEDGE',
              'TEXTO1': 'Percentage of knowledge of FORALL practices in your organization',
              'TITULOSATIS': 'SATISFACTION',
              'TEXTO2': 'Level of satisfaction of employees who know the FORALL practice',
            }
          },

        'DEMOGRAFICOS':{
          'Cargo homologado ': 'Approved position',
          'Años de Trabajo': 'Antique',
            'Condición de trabajo': 'Working Condition',
            'Tipo de trabajo': 'Compensation Scheme',
            'Género': 'Gender',
            'Educación': 'Academic Degree',
            'PORCONOTXT1': 'Percentage of',
            'PORCONOTXT2': 'knowledge of FORALL practices',
            'PORCONOTXT3': 'by demographic cut',
            'PORSATITXT1': 'Level of',
            'PORSATITXT2': 'satisfaction of the employees who know the FORALL practices',
            'PORSATITXT3': 'by demographics',
         }
         },
      },
    }
};
